import React, { useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import ToggleSwitch from '../../shared/utils/CustomToggle';
import { useCityviseApartment, useOnbordApartment } from '../../assets/api/useMarketingExecutive';
import CustomDivider from '../../shared/utils/CustomDivider';
import useAuthStore from '../../store/useAuthStore';
import CommonTermAndCondtion from '../commonfile/CommonTermAndCondtion';

const MarketingMangerTC = () => {
    const { user } = useAuthStore()
    const [showVerified, setShowVerified] = useState(true);
    const handleToggleChange = (isChecked) => {
        setShowVerified(isChecked);
    };
    const { data: CityApartmentList, isLoading: isCityApartmentListLoading } = useCityviseApartment({ city_name: user?.city })
    const { data: apartmentList, isLoading: isApartmentListLoading } = useOnbordApartment({ city_name: user?.city })
    const CityApartmentRow = CityApartmentList?.data.map((item, index) => ({
        ...item,
        sr_no: index + 1,
    }));
    return (
        <>
            <NormalContainerWithHeader headerText={"Terms And Condition"} RightContent={<ToggleSwitch checked={showVerified} onCheck={handleToggleChange} checkedText="Verified" unCheckedText='Verified' />}
            />
            <CustomDivider />
            {
                !showVerified ? <CommonTermAndCondtion apartmentRow={CityApartmentRow} isloadingApartment={isCityApartmentListLoading} /> : <CommonTermAndCondtion apartmentRow={apartmentList?.data} isloadingApartment={isApartmentListLoading} />
            }
        </>

    )
}

export default MarketingMangerTC